import { render, staticRenderFns } from "./study-summary.vue?vue&type=template&id=688c763e&scoped=true&"
import script from "./study-summary.vue?vue&type=script&lang=js&"
export * from "./study-summary.vue?vue&type=script&lang=js&"
import style0 from "./study-summary.vue?vue&type=style&index=0&id=688c763e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688c763e",
  null
  
)

component.options.__file = "study-summary.vue"
export default component.exports